import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { TermsOfService } from '@queries/generated';
import { CurrentUserService } from '@services/current-user.service';

interface Agreeable {
  termsOfService: TermsOfService[];
}

@Component({
  selector: 'vnm-terms-of-service-agreements',
  templateUrl: './terms-of-service-agreements.component.html',
  styleUrls: ['./terms-of-service-agreements.component.scss']
})
export class TermsOfServiceAgreementsComponent implements OnInit, OnChanges {
  @Input() agreeable: Agreeable;
  @Output() canDeactivate = new EventEmitter<boolean>();
  loading = false;

  constructor(private currentUserService: CurrentUserService) {}

  ngOnInit() {
    this.canDeactivate.emit(false);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.agreeable) {
      const canDeactivate = this.agreeable.termsOfService.every((tos) => tos.agreed);
      if (canDeactivate) {
        this.canDeactivate.emit(canDeactivate);
      }
    }
  }

  onAgreed(tos: TermsOfService) {
    const fn = () => {
      this.loading = false;
    };
    this.loading = true;
    this.currentUserService.acceptTermsOfService({ termsOfServiceId: tos.gid }).subscribe(fn, fn);
  }
}
